export const GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA = 'GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA';

export const GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA_SUCCESS = 'GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA_SUCCESS';

export const GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA_FAILED = 'GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA_FAILED';
